/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-filename-extension */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import Select from 'react-select';
import PropTypes from 'prop-types';

import { BoxShadow } from '../../../../../shared/GlobalStyles';

import iconSet from '../../../../../shared/images/teambuildr-selection.json';
import Button from '../../../../../shared/_TBComponents/Button';
import { dashboardTracker } from '../../../../../shared/utils/amplitudeHelper';
import SharedTemplateModalContainer from './SharedTemplateModalContainer';
import {
  editLMTemplate,
  setEditLMDashModal,
} from '../../../../load-monitoring-dashboard/ducks/loadMonitoringDashboardActions';
import {
  editFPTemplate,
  setEditFPDashModal,
} from '../../../../force-plate-dashboard/ducks/forcePlateDashboardActions';
import {
  editDashboard,
  setEditDashboardModal,
} from '../../../../sport-coach-dashboard/ducks/sportCoachDashboardActions';
import {
  editVTTemplate,
  setEditVTDashModal,
} from '../../../../volume-tracker-dashboard/ducks/volumeTrackerDashboardActions';
import { editVBTTemplate, setEditVBTDashModal } from '../../../../vbt-dashboard/ducks/vbtDashboardActions';
import SharedInput from '../../../../../shared/_TBComponents/Input';

const BlockText = styled('div')`
  font-family: "Nunito Sans";
  font-size: 16px;
  font-weight: 500;
`;

const BlockSubtext = styled('div')`
  color: #9E9E9E;
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: 400;
  white-space: break-spaces;
`;

const ButtonContainer = styled('div')`
  background: white;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

const ContentContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  max-height: ${(props) => props.customHeight};
  padding-left: 40px;
  padding-right: 40px;
  transition: max-height 0.5s linear;
  width: 100%;
`;

const Divider = styled('span')`
  align-content: center;
  color: #9E9E9E;
  line-height: 36px;
  margin: 0px 5px;
`;

const ErrorBox = styled('div')`
  display: flex;
  flex-direction: column;
`;

const HeaderIconContainer = styled('div')`
  align-items: center;
  border: 1px solid black;
  border-radius: 50%;
  display: flex;
  height: 52px;
  justify-content: center;
  width: 52px;
`;

const MappedError = styled('div')`
  color: #c0392b;
  font-family: "Nunito Sans";
  font-size: 14px;
`;

const Max = styled('input')`
  border-radius: 4px;
  font-size: 16px;
  padding: 8px 16px;
  width: 45%;
`;

const Min = styled('input')`
  border-radius: 4px;
  font-size: 16px;
  padding: 8px 16px;
  width: 45%;
`;

const ModalContainer = styled('div')`
  border-radius: 12px;
  left: 50%;
  max-height: calc(100vh - 20px);
  max-width: 600px;
  min-height: 270px;
  min-width: 430px;
  overflow: auto;
  position: absolute;
  right: 50%;
  top: 50%;
  transform: ${(props) => (props.isActive ? 'translate(-50%,-50%)' : 'translate(-50%, 300%)')};
  transition: all 0.3s linear, opacity 0.3s ease-out;
  opacity: ${(props) => (props.isActive ? '1' : '0')};
  visibility: ${(props) => (props.isActive ? 'visible' : 'hidden')};
  user-select: none;
  width: 50vw;
  z-index: 1003;
  @media only screen and (max-width: 768px) {
    width: 90vw;
  }
`;

const ModalHeader = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  width: 100%;
`;

const ModalHeaderText = styled('div')`
  font-family: "Nunito Sans";
  font-size: 24px;
  font-weight: 400;
  margin-top: 10px;
`;

const PortalContainer = styled('div')`
  background: white;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: ${BoxShadow};
  overflow: auto;
  width: 100%;
`;

const RemoveDiv = styled('div')`
  background: white;
  color: ${(props) => (props.isDarkMode ? 'white' : '#444444')};
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  width: 100%;
  z-index: 1001;
  .remove-div-icon {
    cursor: pointer;
  }
`;

const Slide = styled('div')`
  display: inline-flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const Slide2Block2 = styled('div')`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  margin-top: 10px;
`;

const SlideIndicator = styled('div')`
  background: ${(props) => (props.isActive ? 'grey' : 'none')};
  border: 1px solid grey;
  border-radius: 50%;
  height: 7px;
  margin-left: 5px;
  margin-right: 5px;
  transition: background-color 0.5s ease;
  width: 7px;
`;

const SlideIndicators = styled('div')`
  align-items: center;
  background: white;
  display: flex;
  height: 40px;
  justify-content: center;
  width: 100%;
`;

const Slides = styled('div')`
  transform: ${(props) => `translateX(-${props.activeSlide * 100}%)`};
  transition: transform 0.5s ease;
  white-space: nowrap;
`;

const SlidesContainer = styled('div')`
  height: auto;
  overflow: hidden;
  width: 100%;
`;

const ThresholdContainer = styled('div')`
  align-items: center;
  display: flex;
  margin-bottom: 5px;
`;

const ThresholdsContainer = styled('div')`
  display: flex;
  flex-direction: ${(props) => (props.direction)};
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0px 10px 25px;
`;

const groupAccessOptions = [
  { name: 'All Groups', id: 1 },
  { name: 'Selected Groups', id: 2 },
  { name: 'Private', id: 3 },
];

const SharedTemplateEditModal = ({ dashboard, legacyName }) => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  let editTemplate = {};
  let groups = [];
  let handleEditTemplate = () => {};
  let isModalShowing = false;
  let setEditModalShowing = () => {};
  let templates = [];
  let vbtGraphThresholds = [];
  let vbtTableThreshold = {};

  const dispatch = useDispatch();

  if (dashboard === 'Force Plate') {
    editTemplate = useSelector(
      (state) => state.forcePlateDashboard.data.editTemplate,
    );
    groups = useSelector((state) => state.forcePlateDashboard.data.groups);
    handleEditTemplate = editFPTemplate;
    isModalShowing = useSelector(
      (state) => state.forcePlateDashboard.ui.editModalShowing,
    );
    setEditModalShowing = setEditFPDashModal;
    templates = useSelector(
      (state) => state.forcePlateDashboard.data.templates,
    );
  }

  if (dashboard === 'Load Monitoring') {
    editTemplate = useSelector(
      (state) => state.loadMonitoringDashboard.data.editTemplate,
    );
    groups = useSelector(
      (state) => state.loadMonitoringDashboard.data.reportableGroups,
    );
    handleEditTemplate = editLMTemplate;
    isModalShowing = useSelector(
      (state) => state.loadMonitoringDashboard.ui.editModalShowing,
    );
    setEditModalShowing = setEditLMDashModal;
    templates = useSelector(
      (state) => state.loadMonitoringDashboard.data.templates,
    );
  }

  if (dashboard === 'Sport Coach') {
    editTemplate = useSelector(
      (state) => state.sportCoachDashboard.data.editTemplate,
    );
    groups = useSelector((state) => state.sportCoachDashboard.data.groups);
    handleEditTemplate = editDashboard;
    isModalShowing = useSelector(
      (state) => state.sportCoachDashboard.ui.editModalShowing,
    );
    setEditModalShowing = setEditDashboardModal;
    templates = useSelector(
      (state) => state.sportCoachDashboard.data.templates,
    );
  }

  if (dashboard === 'VBT') {
    editTemplate = useSelector((state) => state.vbtDashboard.data.editTemplate);
    groups = useSelector((state) => state.vbtDashboard.data.groups);
    handleEditTemplate = editVBTTemplate;
    isModalShowing = useSelector((state) => state.vbtDashboard.ui.editModalShowing);
    setEditModalShowing = setEditVBTDashModal;
    templates = useSelector((state) => state.vbtDashboard.data.templates);
    vbtGraphThresholds = useSelector((state) => state.vbtDashboard.data.graphThresholds);
    vbtTableThreshold = useSelector((state) => state.vbtDashboard.data.tableThreshold);
  }

  if (dashboard === 'Volume Tracker') {
    editTemplate = useSelector(
      (state) => state.volumeTrackerDashboard.data.editTemplate,
    );
    groups = useSelector((state) => state.volumeTrackerDashboard.data.groups);
    handleEditTemplate = editVTTemplate;
    isModalShowing = useSelector(
      (state) => state.volumeTrackerDashboard.ui.editModalShowing,
    );
    setEditModalShowing = setEditVTDashModal;
    templates = useSelector(
      (state) => state.volumeTrackerDashboard.data.templates,
    );
  }

  const [activeSlide, setActiveSlide] = useState(0);
  const [dashDescription, setDashDescription] = useState('');
  const [dashTitle, setDashTitle] = useState('');
  const [errors, setErrors] = useState({
    errorsExist: true,
    errors: [
      {
        error: 'name error',
        msg: 'You must add an evaluation name',
        isShowing: false,
      },
      {
        error: 'incomplete item error',
        msg: 'Some evaluation items are incomplete',
        isShowing: false,
      },
      {
        error: 'need groups error',
        msg: 'You must select at least one group',
        isShowing: false,
      },
      {
        error: 'threshold error',
        msg: 'One or more thresholds are invalid, please check and try again',
        isShowing: false,
      },
      {
        error: 'duplicate threshold error',
        msg: 'You cannot have duplicate performance overview thresholds',
        isShowing: false,
      },
    ],
  });
  const [errorsMulti, setErrorsMulti] = useState(
    dashboard === 'VBT' && vbtGraphThresholds?.length
      ? vbtGraphThresholds.map(() => ({ min: false, max: false }))
      : dashboard === 'VBT' ? [{ min: false, max: false }] : undefined,
  );
  const [errorsThreshold, setErrorsThreshold] = useState(
    dashboard === 'VBT' ? { min: false, max: false } : undefined,
  );
  const [groupAccessBoxActive, setGroupAccessBoxActive] = useState(false);
  const [groupType, setGroupType] = useState({});
  const [gThresholds, setGThresholds] = useState(
    dashboard === 'VBT'
      ? (vbtGraphThresholds?.length
        ? vbtGraphThresholds
        : [{ min: '', max: '' }, { min: '', max: '' }, { min: '', max: '' }])
      : undefined,
  );
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [tThreshold, setTThreshold] = useState(
    dashboard === 'VBT'
      ? { min: vbtTableThreshold.min ?? '', max: vbtTableThreshold.max ?? '' }
      : undefined,
  );

  const uniqueFilters = (filterArray) => {
    if (!filterArray) return [];
    const uniqueArr = [];
    filterArray.forEach((filterObj) => {
      if (!uniqueArr.some((obj) => obj.name === filterObj.name)) uniqueArr.push(filterObj);
    });
    return uniqueArr;
  };
  const fpChartMetrics = uniqueFilters(
    editTemplate?.chartForcePlateMetrics,
  ).map((metricObj) => metricObj.name.replace(/\s/g, ''));

  const fpKeyMetrics = uniqueFilters(
    editTemplate?.kpiForcePlateMetrics,
  ).map((metricObj) => metricObj.name.replace(/\s/g, ''));

  const handleClose = () => {
    dispatch(setEditModalShowing(false));
    if (dashboard === 'VBT') {
      setGThresholds(vbtGraphThresholds?.length ? vbtGraphThresholds : [{ min: '', max: '' }, { min: '', max: '' }, { min: '', max: '' }]);
      setTThreshold({
        min: vbtTableThreshold.min ?? '',
        max: vbtTableThreshold.max ?? '',
      });
      setErrorsThreshold({ min: false, max: false });
      setErrorsMulti(
        vbtGraphThresholds?.length
          ? vbtGraphThresholds.map(() => ({ min: false, max: false }))
          : [{ min: false, max: false }],
      );
    }
  };

  const handleGraphThresholdChange = (index, field, value) => {
    if (dashboard !== 'VBT') return;
    // Limit to 2 decimal places
    const formattedValue = value.includes('.')
      ? value.replace(/\.(\d{0,2}).*/, '.$1')
      : value;

    setGThresholds((prevThresholds) => {
      const updatedThresholds = [...prevThresholds];
      const prev = updatedThresholds[index] || { min: '', max: '' };
      const updated = { ...prev, [field]: formattedValue };
      updatedThresholds[index] = updated;
      setErrorsMulti((prevErrors) => {
        const updatedErrors = [...prevErrors];
        const newMin = updated.min !== undefined ? updated.min : '';
        const newMax = updated.max !== undefined ? updated.max : '';
        const hasValue = newMin !== '' || newMax !== '';
        updatedErrors[index] = {
          min: hasValue && (newMin === '' || Number(newMin) <= 0),
          max: hasValue && (newMax === '' || Number(newMax) <= 0 || (newMin !== '' && Number(newMax) <= Number(newMin))),
        };
        return updatedErrors;
      });
      return updatedThresholds;
    });
  };

  const handleTableThresholdChange = (field, value) => {
    if (dashboard !== 'VBT') return;
    // Limit to 2 decimal places
    const formattedValue = value.includes('.')
      ? value.replace(/\.(\d{0,2}).*/, '.$1')
      : value;

    setTThreshold((prevThreshold) => {
      const updated = { ...prevThreshold, [field]: formattedValue };
      const newMin = updated.min !== undefined ? updated.min : '';
      const newMax = updated.max !== undefined ? updated.max : '';
      const hasValue = newMin !== '' || newMax !== '';
      setErrorsThreshold({
        min: hasValue && (newMin === '' || Number(newMin) <= 0),
        max: hasValue && (newMax === '' || Number(newMax) <= 0 || (newMin !== '' && Number(newMax) <= Number(newMin))),
      });
      return updated;
    });
  };

  const isValidThreshold = (t) => {
    const min = Number(t.min);
    const max = Number(t.max);
    return (
      t.min !== '' && t.max !== '' && !Number.isNaN(min) && !Number.isNaN(max)
    );
  };

  const mapToNumeric = (t) => ({ ...t, min: Number(t.min), max: Number(t.max) });

  const preventEAndMinus = (e) => {
    if (e.key === 'e' || e.key === 'E' || e.key === '-') {
      e.preventDefault();
    }
  };

  const thresholdValidator = () => {
    // Check for individual threshold errors
    const hasTableThresholdErrors = errorsThreshold?.min || errorsThreshold?.max;
    const hasGraphThresholdErrors = gThresholds?.some((t, i) => {
      const err = errorsMulti[i] || {};
      return (err.min || err.max);
    });

    if (hasTableThresholdErrors || hasGraphThresholdErrors) {
      return 'thresholdError';
    }

    // Check for duplicate graph thresholds
    const validGraphThresholds = gThresholds?.filter(isValidThreshold) || [];

    // Normalize thresholds by converting to numbers and creating normalized strings
    const normalizedThresholds = validGraphThresholds.map((t) => {
      const min = Number(t.min);
      const max = Number(t.max);
      return {
        min,
        max,
        normalizedString: `${min}-${max}`,
      };
    });

    // Check for duplicates using normalized values
    const thresholdStrings = normalizedThresholds.map((t) => t.normalizedString);
    const uniqueThresholdStrings = [...new Set(thresholdStrings)];
    const hasDuplicateThresholds = thresholdStrings.length !== uniqueThresholdStrings.length;

    if (hasDuplicateThresholds) {
      return 'duplicatesError';
    }

    return null;
  };

  const submitEdit = () => {
    if (dashTitle.length) {
      if (activeSlide === 0) {
        setActiveSlide(1);
      } else if (dashboard === 'VBT' && activeSlide === 1) {
        const thresholdError = thresholdValidator();
        if (thresholdError) {
          const newErrors = { ...errors };

          if (thresholdError === 'duplicatesError') {
            newErrors.errors[4].isShowing = true;
            newErrors.errors[3].isShowing = false;
          } else if (thresholdError === 'thresholdError') {
            newErrors.errors[3].isShowing = true;
            newErrors.errors[4].isShowing = false;
          }
          setErrors(newErrors);
        } else {
          const newErrors = { ...errors };
          newErrors.errors[3].isShowing = false;
          newErrors.errors[4].isShowing = false;
          setErrors(newErrors);
          setActiveSlide(2);
        }
      } else if (groupType.id === 2 && !selectedGroups.length) {
        const newErrors = { ...errors };
        newErrors.errors[2].isShowing = true;
        setErrors(newErrors);
      } else {
        let submissionObject = {
          title: dashTitle,
          description: dashDescription,
        };
        if (dashboard === 'Load Monitoring') {
          const itemIds = editTemplate?.isQuestionniare
            ? [editTemplate?.questionnaire.id]
            : editTemplate?.questions.map((question) => question.id);
          submissionObject = {
            ...submissionObject,
            groupIds: selectedGroups.map((groupOb) => groupOb.id),
            isQuestionnaire: editTemplate.isQuestionnaire,
            itemIds,
            showAverages: editTemplate.showAverages,
            showTotals: editTemplate.showTotals,
          };
        }
        if (dashboard === 'Force Plate') {
          submissionObject = {
            ...submissionObject,
            chartForcePlateMetrics: fpChartMetrics,
            kpiForcePlateMetrics: fpKeyMetrics,
            groupIds: selectedGroups.map((groupOb) => groupOb.id),
          };
        }
        if (dashboard === 'Sport Coach') {
          submissionObject = {
            ...submissionObject,
            exercises: editTemplate.exerciseIds,
            groups: selectedGroups.map((groupOb) => groupOb.id),
          };
        }
        if (dashboard === 'Volume Tracker') {
          submissionObject = {
            ...submissionObject,
            exerciseIds: editTemplate.exerciseIds,
            groupIds: selectedGroups.map((groupOb) => groupOb.id),
          };
        }
        if (dashboard === 'VBT') {
          submissionObject = {
            ...submissionObject,
            exerciseIds: editTemplate.exerciseIds,
            groupIds: selectedGroups.map((groupOb) => groupOb.id),
            thresholds: {
              graphThresholds: gThresholds.filter(isValidThreshold).map(mapToNumeric),
              tableThreshold: isValidThreshold(tThreshold) ? mapToNumeric(tThreshold) : {},
            },
          };
        }
        const templateIndex = templates.findIndex(
          (template) => template.templateId === editTemplate.templateId,
        );
        dispatch(
          handleEditTemplate(
            currentUser.accountCode,
            submissionObject,
            editTemplate.templateId,
            templateIndex,
          ),
        );
        handleClose();
        // Amplitude tracking
        dashboardTracker(
          `${legacyName} Dashboard`,
          'Edit Saved Dashboard',
          'Dashboard edited',
        );
      }
    } else {
      const newErrors = { ...errors };
      newErrors.errors[0].isShowing = true;
      setErrors(newErrors);
    }
  };

  /**
   * This is a complicated-looking function that actually is quite simple
   * What we're doing here is two-fold:
   * 1. If the editing template has existing information associated with
   * it (e.g. name, description, groups, etc.) we want to pre-fill that
   * information.
   * 2. When the modal is closed, we want to reset the modal's active
   * slide to 1
   */
  useEffect(() => {
    if (editTemplate.description) {
      setDashDescription(editTemplate.description);
    } else {
      setDashDescription('');
    }
    if (editTemplate.title) {
      setDashTitle(editTemplate.title);
    } else {
      setDashTitle('');
    }
    if (editTemplate.thresholds) {
      setGThresholds(editTemplate.thresholds.graphThresholds);
      setTThreshold(editTemplate.thresholds.tableThreshold);
    }
    if (Object.keys(editTemplate).length) {
      if (
        editTemplate.groups.length > 0
          && editTemplate.groups.length < groups.length
      ) {
        setGroupType(groupAccessOptions[1]);
        setSelectedGroups(editTemplate.groups);
      } else if (editTemplate.groups.length === 0) {
        setGroupType(groupAccessOptions[2]);
        setSelectedGroups([]);
      } else if (editTemplate.groups.length === groups.length) {
        setGroupType(groupAccessOptions[0]);
        setSelectedGroups(groups);
      }
    }
    if (!Object.keys(editTemplate).length) {
      setActiveSlide(0);
    }
  }, [editTemplate]);

  useEffect(() => {
    if (Object.keys(editTemplate).length === 0) {
      setErrors({
        errorsExist: true,
        errors: [
          {
            error: 'name error',
            msg: 'You must add an evaluation name',
            isShowing: false,
          },
          {
            error: 'incomplete item error',
            msg: 'Some evaluation items are incomplete',
            isShowing: false,
          },
          {
            error: 'need groups error',
            msg: 'You must select at least one group',
            isShowing: false,
          },
          {
            error: 'threshold error',
            msg: 'One or more thresholds are invalid, please check and try again',
            isShowing: false,
          },
          {
            error: 'duplicate threshold error',
            msg: 'You cannot have duplicate performance overview thresholds',
            isShowing: false,
          },
        ],
      });
    }
  }, [editTemplate]);

  return (
    <>
      <ModalContainer
        onClick={(e) => {
          if (e.target !== 'floating-access-selector' && groupAccessBoxActive) {
            setGroupAccessBoxActive(false);
          }
        }}
        isActive={isModalShowing}
        customWidth={dashboard === 'VBT' ? (activeSlide === 2 ? '550px' : '1000px') : (activeSlide === 1 ? '550px' : '1000px')}
        customHeight={dashboard === 'VBT' ? (activeSlide === 2 && groupType.id !== 2 ? '400px' : '1000px') : (activeSlide === 1 && groupType.id !== 2 ? '400px' : '1000px')}
      >
        <ButtonContainer>
          <PortalContainer>
            <RemoveDiv>
              {activeSlide !== 0 ? (
                <div
                  className='remove-div-icon'
                  onClick={() => {
                    if (dashboard === 'VBT') {
                      if (activeSlide === 1) {
                        const newErrors = { ...errors };
                        newErrors.errors[3].isShowing = false;
                        newErrors.errors[4].isShowing = false;
                        newErrors.errorsExist = false;
                        setErrors(newErrors);
                        setActiveSlide(0);
                      } else {
                        setActiveSlide(1);
                      }
                    } else {
                      setActiveSlide(0);
                    }
                  }}
                >
                  <IcomoonReact
                    iconSet={iconSet}
                    size={18}
                    icon='left-arrow'
                    color='#444444'
                  />
                </div>
              ) : null}
              <ModalHeader>
                <HeaderIconContainer>
                  <IcomoonReact iconSet={iconSet} size={20} icon='pencil' />
                </HeaderIconContainer>
                <ModalHeaderText>Edit Dashboard</ModalHeaderText>
                <ErrorBox>
                  {errors.errors[0].isShowing ? (
                    <MappedError>{errors.errors[0].msg}</MappedError>
                  ) : null}
                  {errors.errors[1].isShowing ? (
                    <MappedError>{errors.errors[1].msg}</MappedError>
                  ) : null}
                  {errors.errors[2].isShowing ? (
                    <MappedError>{errors.errors[2].msg}</MappedError>
                  ) : null}
                  {errors.errors[3].isShowing ? (
                    <MappedError>{errors.errors[3].msg}</MappedError>
                  ) : null}
                  {errors.errors[4]?.isShowing ? (
                    <MappedError>{errors.errors[4].msg}</MappedError>
                  ) : null}
                </ErrorBox>
              </ModalHeader>
              <div className='remove-div-icon' onClick={handleClose}>
                <IcomoonReact
                  iconSet={iconSet}
                  size={15}
                  icon='remove'
                  color='black'
                />
              </div>
            </RemoveDiv>
            <ContentContainer
              customHeight={dashboard === 'VBT' ? (activeSlide === 2 && groupType.id !== 2 ? '200px' : '500px') : (activeSlide === 1 && groupType.id !== 2 ? '200px' : '500px')}
            >
              <SlidesContainer>
                <Slides activeSlide={activeSlide}>
                  <Slide>
                    {/* Title/Description Step */}
                    <SharedInput
                      charLimit={50}
                      fontSize='unset'
                      fontWeight={400}
                      height='40px'
                      label='Title'
                      name='dashTitle'
                      onBlur={() => {
                        if (!dashTitle.length) {
                          const newErrors = { ...errors };
                          newErrors.errors[0].isShowing = true;
                          setErrors(newErrors);
                        }
                      }}
                      onChange={(e) => {
                        if (e.target.value.length <= 50) {
                          if (
                            errors.errors[0].isShowing
                              && e.target.value.length
                          ) {
                            const newErrors = { ...errors };
                            newErrors.errors[0].isShowing = false;
                            setErrors(newErrors);
                          }
                          setDashTitle(e.target.value);
                        }
                      }}
                      placeholder='Title'
                      placeHolderColor='#444444'
                      styledPropsLabel={{
                        marginBottom: 'unset',
                        fontSize: '16px',
                      }}
                      styledPropsWrapper={{
                        display: 'flex',
                        flexDirection: 'column',
                        margin: '10px 0px',
                      }}
                      textColor='#444444'
                      value={dashTitle}
                    />
                    <SharedInput
                      charLimit={500}
                      fontSize='unset'
                      fontWeight={400}
                      height='75px'
                      isTextArea
                      label='Description'
                      name='dashDescription'
                      onChange={(e) => {
                        if (e.target.value.length <= 500) {
                          setDashDescription(e.target.value);
                        }
                      }}
                      placeholder='Description (optional)'
                      placeHolderColor='#444444'
                      styledPropsLabel={{
                        marginBottom: 'unset',
                        fontSize: '16px',
                      }}
                      styledPropsWrapper={{
                        display: 'flex',
                        flexDirection: 'column',
                        margin: '10px 0px',
                      }}
                      textColor='#444444'
                      value={dashDescription}
                    />
                  </Slide>
                  {dashboard === 'VBT' && (
                  <Slide>
                    {/* Thresholds Step */}
                    <BlockText style={{ fontWeight: 700 }}>
                      Performance Overview Thresholds (optional)
                    </BlockText>
                    <BlockSubtext>
                      Visualize targets by adding up to 3 minimum and maximum thresholds below
                    </BlockSubtext>
                    <ThresholdsContainer direction='column'>
                      <ThresholdContainer>
                        <Min
                          id='min-1'
                          min={0}
                          onChange={(e) => handleGraphThresholdChange(0, 'min', e.target.value)}
                          onKeyDown={preventEAndMinus}
                          placeholder='0.4 m/s'
                          step='0.1'
                          style={{
                            border: errorsMulti[0]?.min ? '2px solid #FF0024' : '2px solid #E0E0E0',
                          }}
                          type='number'
                          value={gThresholds[0]?.min || ''}
                        />
                        <Divider>-</Divider>
                        <Max
                          id='max-1'
                          min={0}
                          onChange={(e) => handleGraphThresholdChange(0, 'max', e.target.value)}
                          onKeyDown={preventEAndMinus}
                          placeholder='0.6 m/s'
                          step='0.1'
                          style={{
                            border: errorsMulti[0]?.max ? '2px solid #FF0024' : '2px solid #E0E0E0',
                          }}
                          type='number'
                          value={gThresholds[0]?.max || ''}
                        />
                      </ThresholdContainer>
                      <ThresholdContainer>
                        <Min
                          id='min-2'
                          min={0}
                          onChange={(e) => handleGraphThresholdChange(1, 'min', e.target.value)}
                          onKeyDown={preventEAndMinus}
                          placeholder='0.4 m/s'
                          step='0.1'
                          style={{
                            border: errorsMulti[1]?.min ? '2px solid #FF0024' : '2px solid #E0E0E0',
                          }}
                          type='number'
                          value={gThresholds[1]?.min || ''}
                        />
                        <Divider>-</Divider>
                        <Max
                          id='max-2'
                          min={0}
                          onChange={(e) => handleGraphThresholdChange(1, 'max', e.target.value)}
                          onKeyDown={preventEAndMinus}
                          placeholder='0.6 m/s'
                          step='0.1'
                          style={{
                            border: errorsMulti[1]?.max ? '2px solid #FF0024' : '2px solid #E0E0E0',
                          }}
                          type='number'
                          value={gThresholds[1]?.max || ''}
                        />
                      </ThresholdContainer>
                      <ThresholdContainer>
                        <Min
                          id='min-3'
                          min={0}
                          onChange={(e) => handleGraphThresholdChange(2, 'min', e.target.value)}
                          onKeyDown={preventEAndMinus}
                          placeholder='0.4 m/s'
                          step='0.1'
                          style={{
                            border: errorsMulti[2]?.min ? '2px solid #FF0024' : '2px solid #E0E0E0',
                          }}
                          type='number'
                          value={gThresholds[2]?.min || ''}
                        />
                        <Divider>-</Divider>
                        <Max
                          id='max-3'
                          min={0}
                          onChange={(e) => handleGraphThresholdChange(2, 'max', e.target.value)}
                          onKeyDown={preventEAndMinus}
                          placeholder='0.6 m/s'
                          step='0.1'
                          style={{
                            border: errorsMulti[2]?.max ? '2px solid #FF0024' : '2px solid #E0E0E0',
                          }}
                          type='number'
                          value={gThresholds[2]?.max || ''}
                        />
                      </ThresholdContainer>
                    </ThresholdsContainer>
                    <BlockText style={{ fontWeight: 700 }}>
                      Group Analysis Threshold (optional)
                    </BlockText>
                    <BlockSubtext>
                      Visualize targets by adding minimum and maximum thresholds below
                    </BlockSubtext>
                    <ThresholdsContainer direction='row'>
                      <Min
                        id='min-4'
                        min={0}
                        onChange={(e) => handleTableThresholdChange('min', e.target.value)}
                        onKeyDown={preventEAndMinus}
                        placeholder='0.4 m/s'
                        step='0.1'
                        style={{
                          border: errorsThreshold.min ? '2px solid #FF0024' : '2px solid #E0E0E0',
                        }}
                        type='number'
                        value={tThreshold.min}
                      />
                      <Divider>-</Divider>
                      <Max
                        id='max-4'
                        min={0}
                        onChange={(e) => handleTableThresholdChange('max', e.target.value)}
                        onKeyDown={preventEAndMinus}
                        placeholder='0.6 m/s'
                        step='0.1'
                        style={{
                          border: errorsThreshold.max ? '2px solid #FF0024' : '2px solid #E0E0E0',
                        }}
                        type='number'
                        value={tThreshold.max}
                      />
                    </ThresholdsContainer>
                  </Slide>
                  )}
                  <Slide>
                    <Slide2Block2>
                      <BlockText>Group Access</BlockText>
                      <Select
                        className='item-select'
                        defaultValue={groupType}
                        options={groupAccessOptions}
                        value={groupType}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        onChange={(option) => {
                          setGroupType(option);
                          if (option.id === 1) {
                            setSelectedGroups(groups);
                          }
                          if (option.id === 3) {
                            setSelectedGroups([]);
                          }
                        }}
                      />
                    </Slide2Block2>
                    {groupType.id === 2 ? (
                      <Slide2Block2>
                        <BlockText>Select Groups</BlockText>
                        <Select
                          className='item-select'
                          options={groups}
                          isMulti
                          defaultValue={selectedGroups}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          getOptionLabel={(option) => option.name}
                          getOptionValue={(option) => option.id}
                          onChange={(selectGroups) => {
                            if (
                              errors.errors[2].isShowing
                                && selectGroups.length
                            ) {
                              const newErrors = { ...errors };
                              newErrors.errors[2].isShowing = false;
                              setErrors(newErrors);
                            }
                            setSelectedGroups(selectGroups);
                          }}
                        />
                      </Slide2Block2>
                    ) : null}
                  </Slide>
                </Slides>
              </SlidesContainer>
            </ContentContainer>
          </PortalContainer>
          <SlideIndicators>
            <SlideIndicator isActive={activeSlide === 0} />
            {dashboard === 'VBT' ? <SlideIndicator isActive={activeSlide === 1} /> : null}
            <SlideIndicator isActive={dashboard === 'VBT' ? activeSlide === 2 : activeSlide === 1} />
          </SlideIndicators>
          <Button
            bgColor='#424242'
            bottom
            disable={errors.errorsExist}
            fontSize='14px'
            fullWidth
            large
            name={dashboard === 'VBT' ? (activeSlide !== 2 ? 'Next' : 'Submit') : (activeSlide === 0 ? 'Next' : 'Submit')}
            noBorder
            onClick={submitEdit}
            square
            styledWrapperProps={{
              borderBottomLeftRadius: '12px',
              borderBottomRightRadius: '12px',
            }}
            txtColor='#FFFFFF'
            upperCase
          />
        </ButtonContainer>
      </ModalContainer>
      <SharedTemplateModalContainer
        isModalShowing={isModalShowing}
        onClose={handleClose}
      />
    </>
  );
};

SharedTemplateEditModal.defaultProps = {
  dashboard: 'Load Monitoring',
  legacyName: 'Load Monitoring',
};

SharedTemplateEditModal.propTypes = {
  dashboard: PropTypes.string,
  legacyName: PropTypes.string,
};

export default SharedTemplateEditModal;
